import { z } from "zod";

import { Media, Photo } from "@/components/forms/schemas/media";
import { artistStatsSchema } from "@/pages/artists/schemas/artist.stats";
import { artistTrackSchema } from "@/pages/artists/schemas/artist.track";
import { genreNestedSchema } from "@/pages/genres/schemas/genre.nested.form";

export const artistNestedSchema = z.object({
  id: z.string().nullish(),
  name: z.string(),
  // `EventArtistDbDto.Slug`. The website's event page links each lineup artist
  // by it, and the event update writes `lineup` as sent — so without it here,
  // every IMS save of an event stripped the slug from its whole lineup.
  slug: z.string().nullish(),
  photo: Photo.nullish(),
  media: Media.nullish(),
  genres: z.array(genreNestedSchema).nullish(),
  time: z.string().datetime().nullish(),
  tracks: z.array(artistTrackSchema).nullish().default([]),
  status: z
    .enum(["Unknown", "Unregistered", "InReview", "Incomplete", "Complete"])
    .default("Unknown"),
  followers: z.number().default(0),
  stats: artistStatsSchema.nullish(),
});

export type ArtistNestedType = z.infer<typeof artistNestedSchema>;
